import React from "react"
import { Outlet } from "react-router-dom"

const PageGuard = () => {
  return <Outlet />
}

export default PageGuard
